import { Brain } from "lucide-react";

export const ProviderRankingsPanel = ({ rankings }) => (
  <div className="rounded-lg border border-surface-border bg-surface-card p-6" data-testid="provider-rankings-panel">
    <div className="mb-1 flex items-center gap-2">
      <Brain className="h-4 w-4 text-truth-green" />
      <h2 className="font-heading text-xl font-bold text-white">Model Feedback Loop &mdash; Provider Accuracy</h2>
    </div>
    <p className="mb-4 text-xs text-slate-500">
      Tracked factual-accuracy rate per AI provider from ground-truth-verified Sovereign Pulse runs. The top-ranked
      provider is automatically prioritized in future reputation analysis.
    </p>
    {rankings.length === 0 ? (
      <p className="text-sm text-slate-500" data-testid="provider-rankings-empty">No ground-truth-verified comparisons logged yet.</p>
    ) : (
      <div className="space-y-2" data-testid="provider-rankings-list">
        {rankings.map((r, i) => (
          <div key={r.provider} className="flex items-center justify-between rounded-md border border-surface-border/60 bg-obsidian p-3" data-testid={`provider-ranking-row-${r.provider}`}>
            <span className="text-sm font-semibold capitalize text-white">
              {i === 0 && r.accuracy_rate !== null ? "\u2605 " : ""}{r.provider}
            </span>
            <span className="text-xs text-slate-400">
              {r.accuracy_rate !== null
                ? `${Math.round(r.accuracy_rate * 100)}% accurate (${r.correct_count}/${r.correct_count + r.incorrect_count})`
                : "No data yet"}
            </span>
          </div>
        ))}
      </div>
    )}
  </div>
);
